import React, { useState } from 'react';
import { Box, Paper, Tab } from '@mui/material';
import ConsoleTabs from '../common/ConsoleTabs';
import FixVersionsManagement from './FixVersionsManagement';
import SprintManagement from './SprintManagement';
import TeamManagement from './TeamManagement';
import UpdateSingleItemAdmin from './UpdateSingleItemAdmin';

/**
 * ADO Management component with sub-tabs for Releases, Sprint Management, Team Management, and Update Single Item
 * @returns {JSX.Element} AdoManagement component
 */
const AdoManagement = () => {
  const [subTabValue, setSubTabValue] = useState(0);

  const handleSubTabChange = (event, newValue) => {
    setSubTabValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Paper sx={{ mb: 2 }}>
        <ConsoleTabs
          value={subTabValue}
          onChange={handleSubTabChange}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Releases" />
          <Tab label="Sprint Management" />
          <Tab label="Team Management" />
          <Tab label="Update Single Item" />
        </ConsoleTabs>
      </Paper>

      {subTabValue === 0 && (
        <FixVersionsManagement />
      )}

      {subTabValue === 1 && (
        <SprintManagement />
      )}

      {subTabValue === 2 && (
        <TeamManagement />
      )}

      {subTabValue === 3 && (
        <UpdateSingleItemAdmin />
      )}
    </Box>
  );
};

export default AdoManagement;

